import { render } from "./About.vue?vue&type=template&id=08cd98ad"
const script = {}

import exportComponent from "D:\\OdocsPortal\\odocsportal-frontend-master\\odocsportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__